module.exports = __webpack_public_path__ + "static/media/14a-05_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.98f6e3ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14a/14a-05_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 148
// module chunks = 0